import { ReactNode, RefObject, useRef, useState } from 'react'

const useModal = () => {
	const [modalContent, setModalContent] = useState<ReactNode>(null)
	const [modalOpen, setModalOpen] = useState(false)
	const modalRef = useRef<HTMLElement>(null) // Cuando el componente modal del UiKit se pase a Typescript, cambiar el any por el tipo de las props que se exponga desde ahí.
	const [modalProps, setModalProps] = useState<any>({})

	const modalMount = (content) => {
		if (content) {
			setModalProps(content.props)
			setModalOpen(true)
			setModalContent(content)
		}
	}

	const modalUnmount = (forceRerender?: boolean) => {
		setModalOpen(false)
		setModalContent(null)
		setModalProps(null)
		if (forceRerender) {
			window.location.reload()
		}
	}

	return {
		modalContent,
		modalMount,
		modalOpen,
		modalProps,
		modalRef,
		modalUnmount
	}
}

export default useModal